const convertFileToBase64 = (file: File | Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader?.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result as string);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

const validateFileType = (types: string[], value: any) => {
  if (
    types.includes(value?.type) ||
    types.includes(value?.[0]?.type) ||
    types.includes(value?.[0]?.name?.split(".")?.pop())
  ) {
    return value;
  }
  return `Wrong image format. Only ${types} files are allowed`;
};

const formatFileSize = (bytes: number) => {
  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(0)} MB`;
};

const validateFile = ({
  value,
  types,
  maxSize, // in bytes
}: {
  value: any;
  types?: string[];
  maxSize?: number;
}) => {
  const file = value?.[0] || value;

  if (!(file instanceof File)) return true;

  // Type validation
  if (types && !types.includes(file.type)) {
    return `Invalid file type. Allowed: ${types.join(", ")}`;
  }

  // Size validation
  if (maxSize && file.size > maxSize) {
    return `File must be smaller than ${formatFileSize(maxSize)}`;
  }

  return true;
};

export const fileUtility = {
  convertFileToBase64,
  validateFileType,
  validateFile,
};
